import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatFormFieldAppearance } from '@angular/material/form-field';

@Component({
  selector: 'sc-number-field',
  templateUrl: './number-field.component.html',
  styleUrls: ['./number-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NumberFieldComponent),
      multi: true
    }
  ]
})
export class NumberFieldComponent implements OnInit {
  @Input() disabled: boolean;
  @Input() placeholder: string;
  @Input() required: boolean;
  @Input() hint: string;
  @Input() prefix: string;
  @Input() suffix: string;
  @Input() step: number;
  public formControl: FormControl = new FormControl(null);

  private _value: any;

  private _appearance: MatFormFieldAppearance = 'standard';

  constructor() {}

  @Input() set appearance(appearance: MatFormFieldAppearance) {
    if (appearance) {
      this._appearance = appearance;
    }
  }

  get appearance(): MatFormFieldAppearance {
    return this._appearance;
  }

  onChange = (value: number) => {};
  onTouched = () => {};

  public ngOnInit() {
    this.formControl.valueChanges.subscribe(value => {
      if (!this.disabled) {
        this.onChange(Number(value));
      }
    });
  }

  public writeValue(value: number) {
    this.formControl.setValue(value);
  }

  public registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }
  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
